import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from "@core/scripts/helper/url";
import {useQuery} from "@tanstack/react-query";

const fetchSearchTexts = async () => {

    const absoluteUrl = URL.toAbsolute('/ajax/search/texts/');
    const response = await fetchWithCSRF(absoluteUrl, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch suggestions');
    }

    return response.json();
};

const useSearchTexts = () => {
    return useQuery({
        queryKey: ['search','texts'],
        staleTime: 1000 * 60 * 60,
        queryFn: () => fetchSearchTexts(),
    });
};
export default useSearchTexts;